import { render, staticRenderFns } from "./UCBadge.vue?vue&type=template&id=3a22f637&scoped=true&"
import script from "./UCBadge.vue?vue&type=script&lang=ts&"
export * from "./UCBadge.vue?vue&type=script&lang=ts&"
import style0 from "./UCBadge.vue?vue&type=style&index=0&id=3a22f637&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22f637",
  null
  
)

export default component.exports